import {constants, apiUrl} from "../utils/constants";
import {GET} from "./api.service.wrapper";


export const GetProductTypes = async () => {
    let args = {
        "order-column" : "name",
        "order": "asc",
        "is-paginate":0
    }
    return await GET(apiUrl.product_types, args);
}